// src/context/InvoiceDataContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import { fetchInvoiceProjectData } from "../utils/fetchInvoiceProjectData";
import { transformInvoiceData } from "../utils/transformInvoiceData";

const InvoiceDataContext = createContext();

export const useInvoiceData = () => useContext(InvoiceDataContext);

export const InvoiceDataProvider = ({ children, limit = 100, user }) => {
    const [invoiceData, setInvoiceData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadData = async () => {
            setLoading(true);
            const data = await fetchInvoiceProjectData(limit, user);
            const formattedData = data.map(transformInvoiceData);
            setInvoiceData(formattedData);
            setLoading(false);
        };

        loadData();
    }, [limit, user]);

    return (
        <InvoiceDataContext.Provider value={{ invoiceData, loading }}>
            {children}
        </InvoiceDataContext.Provider>
    );
};
